//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { PreviewGalleryModalAction } from '@galleries/actions/previewGalleryModalActions';
import { PREVIEW_GALLERY_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IPreviewGalleryModalState } from '@galleries/models/previewGalleryModalModel';

const initialState: IPreviewGalleryModalState = {
  isOpen: false,
  previewOptions: undefined,
  alertsDismissed: {},
  flags: {
    isDismissingAlert: false,
    isFetchingDismissedAlerts: false,
  },
};

export default function PreviewGalleryModalReducer(
  state: IPreviewGalleryModalState = initialState,
  action: PreviewGalleryModalAction,
): IPreviewGalleryModalState {
  switch (action.type) {
    case PREVIEW_GALLERY_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.SET_PREVIEW_OPTIONS:
      return {
        ...state,
        previewOptions: action.previewOptions,
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.DISMISS_ALERT: {
      const dismissedAlert = {
        ...state.alertsDismissed[action.alertType],
        isDismissed: true,
      };

      return {
        ...state,
        alertsDismissed: {
          ...state.alertsDismissed,
          [action.alertType]: dismissedAlert,
        },
        flags: {
          ...state.flags,
          isDismissingAlert: true,
        },
      };
    }
    case PREVIEW_GALLERY_MODAL_ACTIONS.DISMISS_ALERT_SUCCEEDED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isDismissingAlert: false,
        },
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.DISMISS_ALERT_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isDismissingAlert: false,
        },
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.REQUEST_DISMISSED_ALERTS:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingDismissedAlerts: true,
        },
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.REQUEST_DISMISSED_ALERTS_FAILED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingDismissedAlerts: false,
        },
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.REQUEST_DISMISSED_ALERTS_SUCCEEDED:
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingDismissedAlerts: false,
        },
        alertsDismissed: action.alertsDismissed,
      };

    case PREVIEW_GALLERY_MODAL_ACTIONS.SET_ALERT_FIRST_AND_LATEST_VIEW: {
      const firstViewAlert = {
        ...state.alertsDismissed[action.alertType],
        lastTimeSeen: action.timestamp,
        firstViewTimestamp: action.timestamp,
      };

      return {
        ...state,
        alertsDismissed: {
          ...state.alertsDismissed,
          [action.alertType]: firstViewAlert,
        },
      };
    }
    case PREVIEW_GALLERY_MODAL_ACTIONS.SET_ALERT_LATEST_VIEW: {
      const latestViewAlert = {
        ...state.alertsDismissed[action.alertType],
        lastTimeSeen: action.timestamp,
      };

      return {
        ...state,
        alertsDismissed: {
          ...state.alertsDismissed,
          [action.alertType]: latestViewAlert,
        },
      };
    }
    default:
      return state;
  }
}
